import * as React from 'react';
import { IconProps } from 'vet-bones/design-system/components';

export const DatabaseRefresh: React.VFC<IconProps> = ({ size }) => {
  return (
    <svg
      fill="none"
      height={size}
      viewBox="0 0 24 24"
      width={size}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 1.5C8.02657 1.5 3.75 2.439 3.75 4.5V18C3.75 19.2598 5.3505 20.0984 7.5 20.5613V19.0268C6.00458 18.6723 5.29102 18.1695 5.25 18V15.3208C6.37028 15.8825 8.00535 16.2323 9.75 16.3934V14.8952C6.84158 14.6122 5.34195 13.8288 5.25 13.4999V10.8207C6.84592 11.6212 9.48195 11.9999 12 11.9999C15.9734 11.9999 20.25 11.0609 20.25 8.99992V4.49962C20.2495 2.43862 15.9732 1.5 12 1.5ZM5.24887 4.51133C5.3631 4.09493 7.61242 3 12 3C16.3482 3 18.5962 4.07557 18.7476 4.5C18.5962 4.92443 16.3482 6 12 6C7.61242 6 5.36317 4.905 5.24887 4.51133ZM18.75 8.99047C18.6295 9.4083 16.381 10.5 12 10.5C7.61242 10.5 5.36318 9.405 5.25 9V6.32078C6.84592 7.12133 9.48195 7.5 12 7.5C14.518 7.5 17.1541 7.12133 18.75 6.32078V8.99047Z"
        fill="currentColor"
      />
      <path
        d="M15.1154 16.4252H13.3085C13.7562 15.7379 14.4143 15.2135 15.1846 14.9302C15.9549 14.6469 16.7963 14.6199 17.5832 14.8531C18.3702 15.0864 19.0606 15.5675 19.5516 16.2247C20.0426 16.8819 20.3078 17.68 20.3077 18.5H21C21.001 17.5752 20.7164 16.6725 20.185 15.9152C19.6536 15.1579 18.9014 14.5827 18.0308 14.2681C17.1602 13.9535 16.2137 13.9148 15.3203 14.1572C14.4269 14.3997 13.6301 14.9115 13.0385 15.623V14.3504H12.3462V17.1168H15.1154V16.4252Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="0.46"
      />
      <path
        d="M17.8846 20.5748H19.6915C19.2438 21.2621 18.5858 21.7865 17.8154 22.0698C17.0451 22.3531 16.2038 22.3801 15.4168 22.1469C14.6298 21.9136 13.9394 21.4325 13.4485 20.7753C12.9575 20.1181 12.6923 19.32 12.6923 18.5H12C11.999 19.4248 12.2837 20.3275 12.815 21.0848C13.3464 21.8421 14.0987 22.4173 14.9692 22.7319C15.8398 23.0465 16.7864 23.0852 17.6798 22.8428C18.5732 22.6003 19.37 22.0885 19.9615 21.377V22.6496H20.6538V19.8832H17.8846V20.5748Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="0.46"
      />
    </svg>
  );
};
